import { styled } from '@mui/material';

export const GridContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'grid',
  // backgroundColor: 'blue',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', // 4 columns with no minimum width on mobile
  gridGap: '0.25rem', // even smaller gap on mobile
  alignItems: 'center',
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))', // 3 columns on tablet
    gridGap: '0.75rem'
  },
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', // 4 columns on desktop
    gridGap: '1rem'
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(4, minmax(10rem, 1fr))', // even smaller minimum width on large screens
    gridGap: '1.5rem'
  }
}));

export const ModernGridContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'grid',
  background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 50%, #e2e8f0 100%)',
  minHeight: '100vh',
  padding: '16px',
  gridTemplateColumns: 'repeat(2, 1fr)', // 2 columns on mobile
  gap: '16px',
  alignItems: 'start',

  // Tablet styles
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)', // Keep 2 columns on small tablets
    gap: '20px',
    padding: '20px'
  },

  // Medium tablets
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(3, 1fr)', // 3 columns on medium screens
    gap: '24px',
    padding: '24px'
  },

  // Desktop
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', // Responsive columns with minimum width
    gap: '28px',
    padding: '32px'
  },

  // Large desktop
  [theme.breakpoints.up('xl')]: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', // Larger cards on bigger screens
    gap: '32px',
    padding: '40px'
  }
}));

// Alternative container for category pages or sections
export const CategoryGridContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'grid',
  background: '#ffffff',
  padding: '20px',
  borderRadius: '16px',
  boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  border: '1px solid #e5e7eb',
  margin: '16px 0',
  gridTemplateColumns: 'repeat(2, 1fr)',
  gap: '16px',

  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '20px',
    padding: '24px'
  },

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '24px',
    padding: '28px'
  },

  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '28px',
    padding: '32px'
  }
}));

// Compact grid for sidebar or featured products
export const CompactGridContainer = styled('div')(({ theme }) => ({
  width: '100%',
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)', // Single column on mobile
  gap: '12px',

  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px'
  },

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px'
  },

  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '20px'
  }
}));
